(() => {
  const HTML_CLASS = 'is-dark-mode-page';
  const LINK_ATTR = 'data-dark-mode-css';

  const ensureCss = (cssUrl) => {
    if (!cssUrl) return;

    const existing = document.querySelector(`link[rel="stylesheet"][${LINK_ATTR}]`);
    if (existing) {
      if (existing.getAttribute('href') !== cssUrl) existing.setAttribute('href', cssUrl);
      return;
    }

    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = cssUrl;
    link.setAttribute(LINK_ATTR, '1');
    document.head.appendChild(link);
  };

  const removeCss = () => {
    const existing = document.querySelector(`link[rel="stylesheet"][${LINK_ATTR}]`);
    if (existing) existing.remove();
  };

  const getAllToggles = () => Array.from(document.querySelectorAll('[data-dark-mode-toggle]'));

  const isAnyEnabled = () => {
    return getAllToggles().some((el) => String(el.dataset.enabled) === 'true');
  };

  const getEnabledCssUrl = () => {
    const el = getAllToggles().find((x) => String(x.dataset.enabled) === 'true' && x.dataset.cssUrl);
    return el ? el.dataset.cssUrl : '';
  };

  const applyState = () => {
    const enabled = isAnyEnabled();

    if (enabled) {
      document.documentElement.classList.add(HTML_CLASS);
      ensureCss(getEnabledCssUrl());
    } else {
      document.documentElement.classList.remove(HTML_CLASS);
      removeCss();
    }
  };

  const applyForSectionId = (sectionId) => {
    if (!sectionId) return applyState();
    applyState();
  };

  document.addEventListener('DOMContentLoaded', applyState);

  document.addEventListener('shopify:section:load', (e) => {
    applyForSectionId(e?.detail?.sectionId);
  });

  document.addEventListener('shopify:section:unload', (e) => {
    applyForSectionId(e?.detail?.sectionId);
  });

  document.addEventListener('shopify:section:select', (e) => {
    applyForSectionId(e?.detail?.sectionId);
  });

  document.addEventListener('shopify:section:deselect', (e) => {
    applyForSectionId(e?.detail?.sectionId);
  });
})();
